import { Box, Paper, Typography } from '@mui/material';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import clientConfig from '../../../client-config';

const columns = [
  { field: 'Year', headerName: 'Év', width: 100 },
  { field: 'Month', headerName: 'Hónap', width: 100 },
  {
    field: 'Income',
    headerName: 'Bevétel',
    width: 150,
    //type: 'number',
  },
  {
    field: 'Costs',
    headerName: 'Költségek',
    width: 150,
    // type: 'number',
  },
  {
    field: 'Provision',
    headerName: 'Jutalék',
    width: 150,
    // type: 'number',
  },
  {
    field: 'Payout',
    headerName: 'Kifizetés',
    width: 150,
    // type: 'number',
  },
  {
    field: 'GrossWin',
    headerName: 'Bruttó nyereség',
    width: 170,
    //  type: 'number',
  },
  {
    field: 'Balance',
    headerName: 'Jutalék egyenleg',
    width: 170,
    //  type: 'number',
  },
];

export default function IncomeStat() {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    axios
      .get(`${clientConfig.backendHOST}/reports/incomeStat`, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'x-auth-token': localStorage.token,
        },
      })
      .then((res) => {
        const dataWithId = res.data.map((item, index) => ({
          id: `${item.Year}-${item.Month}`, // szükséges unique ID
          ...item,
        }));
        setRows(dataWithId);
      });
  }, []);

  return (
    <Box className='content-block' sx={{ px: 2, pt: 2 }}>
      <Paper elevation={3} sx={{ p: 2, mb: 3 }}>
        <Typography variant='h5' gutterBottom>
          Havi statisztika
        </Typography>
        <Box sx={{ height: 600, width: '100%' }}>
          <DataGrid
            rows={rows}
            columns={columns}
            pageSize={25}
            rowsPerPageOptions={[25, 50, 100]}
            disableSelectionOnClick
            slots={{ toolbar: GridToolbar }}
            slotProps={{
              toolbar: { csvOptions: { delimiter: ';', utf8WithBom: true } },
            }}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
            }
          />
        </Box>
      </Paper>
    </Box>
  );
}
